import * as constants from "constants/confirmation.constants";

const initialState = {
  loading: false,
  ready: false,
  success: null,
  submitted: false,
  errorCode: null,

  background: null,
  name: null,
  confirmed: false,
  email: null,
  firstname: null,
  lastname: null,

  reset_password: false,
  signup: false,
  email_change: false,
  confirm_email: false,
  has_password: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.CONFIRMATION_INFO.REQUEST:
    case constants.CONFIRMATION_SUBMIT.REQUEST:
      return {
        ...state,
        loading: true,
        success: null,
        error: null,
      };
    case constants.CONFIRMATION_INFO.SUCCESS: {
      const data = action.data;

      return {
        ...state,
        ...data,
        loading: false,
        success: true,
      };
    }
    case constants.CONFIRMATION_SUBMIT.SUCCESS: {
      return {
        ...state,
        loading: false,
        submitted: true,
      };
    }
    case constants.CONFIRMATION_INFO.FAILURE:
    case constants.CONFIRMATION_SUBMIT.FAILURE: {
      let { code: errorCode } = action?.data?.message || {};

      if (action?.data?.status === 404) {
        errorCode = 104;
      }

      return {
        ...state,
        loading: false,
        success: false,
        error: action.data,
        errorCode: errorCode,
      };
    }
    default:
      return state;
  }
};

export default reducer;